import { render, staticRenderFns } from "./DetailBagageClient.vue?vue&type=template&id=471ae71c&scoped=true"
import script from "./DetailBagageClient.vue?vue&type=script&lang=js"
export * from "./DetailBagageClient.vue?vue&type=script&lang=js"
import style0 from "./DetailBagageClient.vue?vue&type=style&index=0&id=471ae71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471ae71c",
  null
  
)

export default component.exports